"use client";

import { useEffect } from "react";
import { afterEngagement } from "@/lib/analytics/engagement";

/**
 * Loads Meta's fbevents.js once the visitor engages. The fbq queue stub
 * (TrackingPixels) is already in the page, so init, PageView and any events
 * fired before this point are replayed by the library when it arrives.
 */
export function MetaPixelLoader() {
  useEffect(() => {
    afterEngagement(() => {
      if (document.getElementById("meta-pixel-lib")) return;
      const s = document.createElement("script");
      s.id = "meta-pixel-lib";
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
    });
  }, []);
  return null;
}
